import { Card } from 'antd';
import clsx from 'clsx';
import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import React from 'react';
import containerStyles from 'order/containers/purchase-result.container/style.module.scss';

const PurchaseResultSkeleton: React.FC = () => {
  return (
    <Container>
      <div className={containerStyles['purchase-result-container']}>
        <div className={containerStyles['success-alert-container']}>
          <Pulsate width='100%' height='60px' />
        </div>
        <div className={containerStyles['resume-container']}>
          <Card>
            <Pulsate width='30%' height='24px' marginBottom='16px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' />
          </Card>
        </div>
        <div className={containerStyles['payment-details-container']}>
          <Card>
            <Pulsate width='30%' height='24px' marginBottom='16px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' marginBottom='8px' />
            <Pulsate width='100%' height='20px' />
          </Card>
        </div>
        <div className={containerStyles['purchase-details-container']}>
          <div className={clsx(containerStyles['child'])}>
            <Pulsate width='40%' height='20px' marginBottom='12px' />
            <Card>
              <Pulsate width='100%' height='150px' />
            </Card>
          </div>
          <div className={clsx(containerStyles['child'])}>
            <Pulsate width='40%' height='20px' marginBottom='12px' />
            <Card>
              <Pulsate width='100%' height='70px' marginBottom='12px' />
              <Pulsate width='100%' height='70px' marginBottom='12px' />
              <Pulsate width='100%' height='70px' />
            </Card>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PurchaseResultSkeleton;
